import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { mdiClose, mdiDragHorizontalVariant } from '@mdi/js';
import { Select } from 'antd';
import type { LabeledValue, RenderSettingsScope } from 'common/models';
import { Icon, ListItem } from 'components';
import { getScopeTranslateKey } from 'helpers/renderSettings';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  value: string;
  options: string[];
  // Use for dynamic options, like serivceObjectRevisionCategories
  allAdditionalOptions?: LabeledValue[];
  filteredAdditionalOptions?: LabeledValue[];
  scope: RenderSettingsScope;
  onFieldIdChange: (oldFieldId: string, newFieldId: string) => void;
  onRemoveClick: (fieldId: string) => void;
  enableRemove: boolean;
}

const RenderSettingsItem: React.FC<Props> = (props) => {
  const {
    value,
    options,
    onFieldIdChange,
    onRemoveClick,
    scope,
    enableRemove,
    allAdditionalOptions,
    filteredAdditionalOptions
  } = props;

  const { t } = useCustomTranslation();

  let optionsWithValue = options;
  let additionalOptions = filteredAdditionalOptions || [];

  if (allAdditionalOptions?.find((x) => x.value === value)) {
    additionalOptions = [
      allAdditionalOptions.find((x) => x.value === value)!,
      ...additionalOptions
    ];
  } else {
    optionsWithValue = [value, ...options];
  }

  const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef } =
    useSortable({
      id: value
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ListItem customClassName="RenderSettingsItem">
        <div className="RenderSettingsItem_content">
          <div
            className="RenderSettingsItem_dragHandle"
            ref={setActivatorNodeRef}
            {...attributes}
            {...listeners}
          >
            <Icon className="drag" path={mdiDragHorizontalVariant} />
          </div>
          <Select
            value={value}
            onChange={(newValue) => onFieldIdChange(value, newValue)}
            className="RenderSettingsItem_select"
            options={[
              ...optionsWithValue.map((option) => ({
                value: option,
                label: t(`renderSettings.labels.${getScopeTranslateKey(scope)}.${option}`),
                title: t(`renderSettings.labels.${getScopeTranslateKey(scope)}.${option}`)
              })),
              ...additionalOptions
            ]}
          />
          {enableRemove && (
            <Icon path={mdiClose} onClick={() => onRemoveClick(value)} className="delete" />
          )}
        </div>
      </ListItem>
    </div>
  );
};

export default RenderSettingsItem;
